module.exports = __webpack_public_path__ + "static/media/avatar.b70c59db.png";